module.exports = __webpack_public_path__ + "img/hockey-mask.24e8b480.svg";